import useAxiosInterceptor from 'src/services/interceptor';
import { laborHoursApiConstant } from '../constants';

class LaborHoursService {
  private axiosInstance;

  constructor() {
    // eslint-disable-next-line react-hooks/rules-of-hooks -- factory, not a React hook (matches npcLogService)
    this.axiosInstance = useAxiosInterceptor();
  }

  getLaborHoursList = (payload: any) => {
    return this.axiosInstance.get(`${laborHoursApiConstant.getLaborHours}`, {
      params: payload,
    });
  };
  getLaborCodesList = () => {
    return this.axiosInstance.get(`${laborHoursApiConstant.labourManagement}/labor-codes`);
  };

  addLaborHour = (payload: any) => {
    const { param, ...restPayload } = payload;
    return this.axiosInstance.post(`${laborHoursApiConstant.addLaborHrs}`, restPayload, {
      params: param,
    });
  };

  editLaborHour = (payload: any) => {
    const { param, ...restPayload } = payload;
    return this.axiosInstance.put(`${laborHoursApiConstant.editLaborHours}`, restPayload, {
      params: param,
    });
  };
  getLocationType = () => {
    return this.axiosInstance.get(`${laborHoursApiConstant.locationType}`);
  };
  getLaborReport = (payload: any) => {
    return this.axiosInstance.get(`${laborHoursApiConstant.laborReport}`, {
      params: payload,
      // arrays serialize as repeated keys (facilityIds=a&facilityIds=b), not facilityIds[]=a
      paramsSerializer: { indexes: null },
    });
  };
  getBuildingsOverview = (payload: any) => {
    return this.axiosInstance.get(`${laborHoursApiConstant.buildingsOverview}`, {
      params: payload,
    });
  };
  // Full audit trail for a single punch — the report only carries a summary of it.
  getLaborEntryHistory = (payload: any) => {
    return this.axiosInstance.get(
      laborHoursApiConstant.laborEntryHistory(payload?.labourManagementId)
    );
  };

  // Approve / unapprove / not-approve all go through one endpoint, switched on `status`.
  // No body — `reason` is a query param and only carries for NOT_APPROVED.
  updateLaborEntryStatus = (payload: any) => {
    const { labourManagementId, status, reason } = payload || {};
    return this.axiosInstance.put(
      `${laborHoursApiConstant.laborEntryStatus(labourManagementId)}`,
      {},
      { params: { status, ...(reason ? { reason } : {}) } }
    );
  };
  getLaborValidationToggle = () => {
    return this.axiosInstance.get(`${laborHoursApiConstant.laborValidationToggle}`);
  };
  getPayPeriodCycles = (payload: any) => {
    return this.axiosInstance.get(`${laborHoursApiConstant.payPeriodCycles}`, {
      params: payload,
    });
  };

  getPayPeriodByDate = (payload: any) => {
    return this.axiosInstance.get(`${laborHoursApiConstant.payPeriodByDate}`, {
      params: { date: payload?.date },
    });
  };

  approvePayPeriod = (payload: any) => {
    const { startDate, endDate, reopen, facilityId } = payload || {};
    return this.axiosInstance.post(
      `${laborHoursApiConstant.payPeriodCycles}`,
      {},
      // facilityId is set only when approving a single building from the buildings list
      { params: { startDate, endDate, reopen: !!reopen, ...(facilityId ? { facilityId } : {}) } }
    );
  };

  deleteLaborHour = (payload: any) => {
    return this.axiosInstance.delete(`${laborHoursApiConstant.deleteLabor}/${payload}`);
  };
}

const laborHoursService = new LaborHoursService();

Object.freeze(laborHoursService);

export default laborHoursService;
